import React from 'react';

import { validate } from 'validate.js';
import { Row, Col, Modal, Button, Input, Divider, Form, Select } from 'antd';
import { _success, _setAxios, _validationFormMsg } from '../../../../../lib/Helper';
import { angsuranOptions, jenisPembayaranOptions } from '../../../../../data/options';

import "./style.css"

const { Option } = Select;
const { TextArea } = Input;

let schema = {
    nama: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
    jenis_pembayaran: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
    angsuran: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    }
};

class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,

            visible: false,
        };
    }

    componentDidMount() {
        this.setState({
            values: this.props.data,
        })
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = async () => {
        const { values } = this.state
        let newSchema = schema
        if (values.angsuran === "1") {
            newSchema = {
                ...schema,
                frekuensi_pembayaran: {
                    presence: { allowEmpty: false, message: 'harus diisi' },
                    format: {
                        pattern: /^$|[1-9]+/,
                        message: function () {
                            return validate.format("^Jumlah angsuran harus berupa agka & minimal 1");
                        }
                    },
                }
            }
        }

        const errors = validate(values, newSchema);
        if (errors) {
            return _validationFormMsg(errors)
        }
        this.setState({
            loading: true
        });
        const params = {
            nama: values.nama ? values.nama : null,
            jenis_pembayaran: values.jenis_pembayaran ? values.jenis_pembayaran : null,
            angsuran: values.angsuran ? values.angsuran : null,
            frekuensi_pembayaran: values.angsuran === "1" ? values.frekuensi_pembayaran ? values.frekuensi_pembayaran : null : 1,
            keterangan: values.keterangan ? values.keterangan : null,
        }

        let endpoint = "keuangan/pemasukan/jenis-pos"
        let method = "POST"
        if (values.id) {
            endpoint = endpoint + "/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {
        const { values } = this.state

        return (
            <Modal
                maskClosable={false}
                title={"Form Master Jenis POS Pemasukan"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={null}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={this.handleSubmit}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24}>
                            <Form.Item label="Nama POS *">
                                <Input
                                    name="nama"
                                    placeholder="Nama POS"
                                    defaultValue={this.props.data.nama}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("nama", e.target.value)
                                    }} />
                            </Form.Item>
                            <Form.Item label="Jenis Pembayaran *">
                                <Select
                                    name="jenis_pembayaran"
                                    placeholder="Jenis Pembayaran"
                                    defaultValue={this.props.data.jenis_pembayaran}
                                    onChange={(_, val) => {
                                        this.handleChangeSetValue("jenis_pembayaran", val.value)
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    {jenisPembayaranOptions.map((row, i) => <Option key={i} value={row.value}>{row.label}</Option>)}
                                </Select>
                            </Form.Item>
                            <Form.Item label="Angsuran *">
                                <Select
                                    name="angsuran"
                                    placeholder="Angsuran"
                                    defaultValue={this.props.data.angsuran}
                                    onChange={(e, val) => {
                                        this.handleChangeSetValue("angsuran", val.value)
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    {angsuranOptions.map((row, i) => <Option key={i} value={row.value}>{row.label}</Option>)}
                                </Select>
                            </Form.Item>
                            {
                                values.angsuran === "1" ? <Form.Item label="Frekuensi Pembayaran *">
                                    <Input
                                    type='number'
                                        name="frekuensi_pembayaran"
                                        placeholder="0"
                                        defaultValue={this.props.data.frekuensi_pembayaran}
                                        onChange={(e) => {
                                            this.handleChangeSetValue("frekuensi_pembayaran", e.target.value)
                                        }} />
                                </Form.Item> : ""
                            }
                        </Col>
                        <Col xs={24}>
                            <Form.Item label="Keterangan">
                                <TextArea
                                    rows={4}
                                    placeholder="Keterangan"
                                    defaultValue={this.props.data.keterangan}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("keterangan", e.target.value)
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} style={{ textAlign: "right" }}>
                            <Divider />
                            <Button onClick={this.props.hideModal}>Batal</Button> &nbsp;
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>Simpan</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default FormContent;
